import { Component, ElementRef, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppConfig } from "@core_n/app.config";
import { ZIndexMngr } from "@core_n/common/ZIndexMngr";
import { dialogType } from "@core_n/enums";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as utils from "../../common/utils";
import { Layout, Preset } from "../preset.model";
import { PresetService } from "./../preset.service";

export type PresetWindowState = "addPreset" | "showPreset" | "updatePreset";

@Component({
  selector: "app-preset",
  templateUrl: "./preset.component.html",
  styleUrls: ["./preset.component.scss"],
})
export class PresetComponent extends ZIndexMngr implements OnInit {
  state: PresetWindowState = "addPreset";
  title: string = "Add Preset";

  form!: FormGroup;
  presetLayouts: Layout[] = AppConfig.presets;
  presetLayout: Layout;

  private _unsubscribeAll$ = new Subject();
  preset: Preset;

  constructor(
    public dialogRef: MatDialogRef<PresetComponent>,
    elementRef: ElementRef,
    private fb: FormBuilder,
    private _presetService: PresetService,
    @Inject(MAT_DIALOG_DATA) private data: { state: PresetWindowState }
  ) {
    super(elementRef);
  }

  ngOnInit(): void {
    this.state = this.data.state
    this.createForm();
    this.loadPreset();
  }

  loadPreset() {
    this._presetService.preset$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((presetUpdate) => this.setPreset(presetUpdate));
  }

  setPreset(preset: Preset) {
    this.preset = preset;
    this.presetLayout = this.presetLayouts.find(
      (pt) => preset.layoutId == pt.id
    );
    const prestNameControl = this.form.controls["presetName"];
    prestNameControl.setValue(this.preset.name);
    prestNameControl.enable();
    switch(this.state){
      case "showPreset": 
      prestNameControl.disable();
      this.title = "Preset Details";
      break;
      case "addPreset":
        this.title = "Add Preset";
        break;
      case "updatePreset":
        this.title =  "Update Preset";

    }
    if (this.state == "showPreset") {
    } else {
    }
  }

  onSubmit() {
    this.preset.name = this.form.value.presetName;
    this.preset.layoutId = this.presetLayout.id;
    if(this.state == "addPreset"){
      this._presetService.addPreset(this.preset);
    }
    else {
      this._presetService.updatePreset(this.preset);
    }

    this.dialogRef.close();
  }

  createForm() {
    this.form = this.fb.group({
      presetName: ["", Validators.required],
      // type: ["", Validators.required],
    });
  }

  static createDialogConfig() {
    return utils.createDialogConfig(false, false, dialogType.AnalysisWindow, {
      top: `${150}px`,
      left: `100px`,
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
      this.dialogRaise();
    });
  }

  ngOnDestroy() {
    this._unsubscribeAll$.next(null);
    this._unsubscribeAll$.complete();
  }
}
